import { render, staticRenderFns } from "./ShortlistItem.vue?vue&type=template&id=7a095b16&scoped=true&"
import script from "./ShortlistItem.vue?vue&type=script&lang=js&"
export * from "./ShortlistItem.vue?vue&type=script&lang=js&"
import style0 from "./ShortlistItem.vue?vue&type=style&index=0&id=7a095b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a095b16",
  null
  
)

export default component.exports